import { useMutateEntry } from '@utils/component-framework';

const useUpdateLocationMutation = entryKey => {
  const updateComponentEntry = useMutateEntry(entryKey);
  return currentIndex => {
    updateComponentEntry(entry => {
      entry.data.currentIndex = currentIndex;
      return entry;
    });
  };
};

export { useUpdateLocationMutation };
//# sourceMappingURL=mutation.update-location.js.map
